<div class="modal-body" data-testid="confirm-modal">
  <h3 *ngIf="title">{{title | translate}}</h3>
  <div *ngIf="body" class="spacer-md" [innerHTML]="body"></div>

  <div class="text-center khModalButtons">
    <button class="btn btn-primary" (click)="onFirstButtonClick()" *ngIf="firstButtonText" data-testid="primary-button">{{firstButtonText | translate}}</button>
    <button class="btn btn-default ml-1" (click)="onSecondButtonClick()" *ngIf="secondButtonText" data-testid="secondary-button">{{secondButtonText | translate}}</button>
  </div>
</div>
